import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import api from "../../services/api";
import InputMask from "react-input-mask";
import "react-toastify/dist/ReactToastify.css";
import "../Motorista/motoristaUp.scss";
import { getTipoLabel } from "./TipoMotorista";
import Swal from "sweetalert2";
import { BiSolidEdit } from "react-icons/bi";
import Tooltip from "@mui/material/Tooltip";
import { TbLock } from "react-icons/tb";

import { TIPOS } from "./TipoMotorista";






function MotoristaUp() {
  const navigate = useNavigate();
  const location = useLocation();

  //  motorista vem da navegação
  const motorista = location.state?.motorista;

  const [values, setValues] = useState({});
  const [disabledCartao, setDisabledCartao] = useState(true);
  // ALTERAR NOME
  const [editarNome, setEditarNome] = useState(false);
  // ALTERAR APELIDO
  const [editarApelido, setEditarApelido] = useState(false);

  // ALTERAR CARTÃO DE ACESSO
  const [editarcartao, setEditarCartao] = useState(false);

  // ALTERAR FUNÇÃO DO FUNCIONARIO
  const [editarTipo, setEditarTipo] = useState(false);

  // ALTERAR DATA VENCIMENTO CNH

  const [editarVencimento, setEditarVencimento] = useState(false);

  // VERIFICAR SE HOUVE ALGUMA ALTERAÇÃO 
  const [originalValues, setOriginalValues] = useState(null);









  const handleVencimentoChange = (e) => {
    const value = e.target.value;
    setDataVencimentoTexto(value);

    if (!value) {
      setValues((prev) => ({ ...prev, data_vencimento: "" }));
      setDataVencimentoError("");
      return;
    }

    const [d, m, a] = value.split("/").map(Number);
    const data = new Date(a, m - 1, d);

    if (isNaN(data.getTime()) || a < 2000) {
      setDataVencimentoError("Data inválida");
      return;
    }


    if (data <= new Date()) {
      setDataVencimentoError("CNH vencida");

      setValues((prev) => ({
        ...prev,
        data_vencimento: moment(data).format("YYYY-MM-DD"),
      }));

      return;
    }

    setValues((prev) => ({
      ...prev,
      data_vencimento: moment(data).format("YYYY-MM-DD"),
    }));

    setDataVencimentoError("");
  };





  //FUNÇÃO PARA VALIDAÇÃO CNH 







  const [cpfError, setCpfError] = useState("");
  const [dataNascimentoError, setDataNascimentoError] = useState("");
  const [dataVencimentoError, setDataVencimentoError] = useState("");

  const [editandoData, setEditandoData] = useState(false);
  const [dataVencimentoTexto, setDataVencimentoTexto] = useState("");

  // Se acessar direto sem state → bloqueia
  useEffect(() => {
    if (!motorista) {
      toast.error("Motorista não encontrado");
      navigate(-1);
    }
  }, [motorista, navigate]);

  //  Inicializa formulário
  useEffect(() => {
    if (!motorista) return;

    const inicial = {
      id: motorista.id,
      nome: motorista.nome || "",
      apelido: motorista.apelido || "",
      cpf: motorista.cpf || "",
      data_nascimento: motorista.data_nascimento || "",
      tipo: motorista.tipo || "",
      num_pis: motorista.num_pis || "",
      num_cnh: motorista.num_cnh || "",
      categoria: motorista.categoria || "",
      cnpj: motorista.cnpj || "",
      num_cartao_acesso: motorista.num_cartao_acesso || "",
      data_vencimento: motorista.data_vencimento || "",
    };


    // 🔹 valores atuais
    setValues(inicial);

    // 🔹 valores originais (para comparação)
    setOriginalValues(inicial);

    if (motorista.data_vencimento) {
      setDataVencimentoTexto(
        moment(motorista.data_vencimento).format("DD/MM/YYYY")
      );
    }
  }, [motorista]);


  // HOUVE ALTERAÇÃO?
  const houveAlteracao = () => {
    return JSON.stringify(values) !== JSON.stringify(originalValues);
  };



  //  Alterações Nome
  const handleChange = (e) => {
    const { name, value } = e.target;

    setValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };



  //FUNÇÃO PARA ALTERAR NOME
  const confirmarEdicaoNome = () => {
    if (editarNome) return;

    Swal.fire({
      width: "520px",
      padding: "0",

      background: "#0f172a",
      color: "#ffffff",

      html: `
      <div class="confirmar-edicao-modal">

        <!-- HEADER -->
        <div class="confirmar-edicao-header">

          <div class="confirmar-edicao-icon">
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M12 20h9"/>
              <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z"/>
            </svg>
          </div>

          <div>
            <h2>
              Alterar nome completo
            </h2>

            <span>
              Confirme para liberar a edição
            </span>
          </div>

        </div>


        <!-- CONTEÚDO -->
        <div class="confirmar-edicao-content">

          <div class="confirmar-edicao-text">
            Essa ação permitirá editar o nome completo do
            <strong>
              ${getTipoLabel(motorista.tipo)}
            </strong>.
          </div>


          <!-- DADOS -->
          <div class="confirmar-edicao-info">

            <div class="confirmar-edicao-item">

              <span>
                Nome atual
              </span>

              <strong>
                ${motorista.nome || "Não informado"}
              </strong>

            </div>


            <div class="confirmar-edicao-item">

              <span>
                Função
              </span>

              <strong>
                ${getTipoLabel(motorista.tipo)}
              </strong>

            </div>

          </div>


          <!-- AVISO -->
          <div class="confirmar-edicao-aviso">

            <svg
              width="17"
              height="17"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>

            <span>
              Após confirmar, o campo será desbloqueado para edição.
            </span>

          </div>

        </div>

      </div>
    `,

      showCancelButton: true,

      confirmButtonText: "Liberar edição",
      cancelButtonText: "Cancelar",

      confirmButtonColor: "#147fc1",
      cancelButtonColor: "#1e293b",

      reverseButtons: true,

      customClass: {
        popup: "swal-confirmar-edicao",
        actions: "swal-confirmar-edicao-actions",
        confirmButton: "swal-confirmar-edicao-confirm",
        cancelButton: "swal-confirmar-edicao-cancel"
      }
    }).then((result) => {

      if (!result.isConfirmed) return;

      setEditarNome(true);


      /* ============================================
         EDIÇÃO LIBERADA
      ============================================ */

      Swal.fire({

        width: "420px",
        padding: "0",

        background: "#0f172a",
        color: "#ffffff",

        html: `
        <div class="edicao-liberada-modal">

          <div class="edicao-liberada-icon">

            <svg
              width="26"
              height="26"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M20 6 9 17l-5-5"/>
            </svg>

          </div>


          <h2>
            Edição liberada
          </h2>


          <p>
            Agora você pode alterar o nome completo.
          </p>


          <span>
            O campo foi desbloqueado para edição.
          </span>

        </div>
      `,

        confirmButtonText: "Entendi",

        confirmButtonColor: "#147fc1",

        customClass: {
          popup: "swal-edicao-liberada",
          confirmButton: "swal-edicao-liberada-confirm"
        }

      });

    });
  };


  //FUNÇÃO PARA ALTERAR APELIDO
const confirmarEdicaApelido = () => {
  if (editarApelido) return;

  Swal.fire({
    width: "520px",
    padding: "0",

    background: "#0f172a",
    color: "#ffffff",

    html: `
      <div class="confirmar-edicao-modal">

        <!-- HEADER -->
        <div class="confirmar-edicao-header">

          <div class="confirmar-edicao-icon">
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M12 20h9"/>
              <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z"/>
            </svg>
          </div>

          <div>
            <h2>
              Alterar apelido
            </h2>

            <span>
              Confirme para liberar a edição
            </span>
          </div>

        </div>


        <!-- CONTEÚDO -->
        <div class="confirmar-edicao-content">

          <div class="confirmar-edicao-text">
            Essa ação permitirá editar o apelido do funcionário.
          </div>


          <!-- DADO ATUAL -->
          <div class="confirmar-edicao-info">

            <div
              class="confirmar-edicao-item"
              style="grid-column: 1 / -1;"
            >

              <span>
                Apelido atual
              </span>

              <strong>
                ${values.apelido || "Não informado"}
              </strong>

            </div>

          </div>


          <!-- AVISO -->
          <div class="confirmar-edicao-aviso">

            <svg
              width="17"
              height="17"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>

            <span>
              Após confirmar, o campo será liberado para edição.
            </span>

          </div>

        </div>

      </div>
    `,

    showCancelButton: true,

    confirmButtonText: "Liberar edição",
    cancelButtonText: "Cancelar",

    confirmButtonColor: "#147fc1",
    cancelButtonColor: "#1e293b",

    reverseButtons: true,

    customClass: {
      popup: "swal-confirmar-edicao",
      actions: "swal-confirmar-edicao-actions",
      confirmButton: "swal-confirmar-edicao-confirm",
      cancelButton: "swal-confirmar-edicao-cancel"
    }

  }).then((result) => {

    if (!result.isConfirmed) return;

    setEditarApelido(true);


    /* ============================================
       EDIÇÃO LIBERADA
    ============================================ */

    Swal.fire({

      width: "420px",
      padding: "0",

      background: "#0f172a",
      color: "#ffffff",

      html: `
        <div class="edicao-liberada-modal">

          <div class="edicao-liberada-icon">

            <svg
              width="26"
              height="26"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M20 6 9 17l-5-5"/>
            </svg>

          </div>


          <h2>
            Edição liberada
          </h2>


          <p>
            Agora você pode alterar o apelido.
          </p>


          <span>
            O campo foi desbloqueado para edição.
          </span>

        </div>
      `,

      confirmButtonText: "Entendi",

      confirmButtonColor: "#147fc1",

      customClass: {
        popup: "swal-edicao-liberada",
        confirmButton: "swal-edicao-liberada-confirm"
      }

    });

  });
};

  //FUNÇÃO PARA ALTERAR CARTÃO DE ACESSO
const confirmarEdicaoCartaoAcesso = () => {
  if (editarcartao) return;

  Swal.fire({
    width: "520px",
    padding: "0",

    background: "#0f172a",
    color: "#ffffff",

    html: `
      <div class="confirmar-edicao-modal">

        <!-- HEADER -->
        <div class="confirmar-edicao-header">

          <div class="confirmar-edicao-icon">

            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M12 20h9"/>
              <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z"/>
            </svg>

          </div>

          <div>

            <h2>
              Alterar cartão de acesso
            </h2>

            <span>
              Confirme para liberar a edição
            </span>

          </div>

        </div>


        <!-- CONTEÚDO -->
        <div class="confirmar-edicao-content">

          <div class="confirmar-edicao-text">
            Essa ação permitirá editar o cartão de acesso do funcionário.
          </div>


          <!-- CARTÃO ATUAL -->
          <div class="confirmar-edicao-info">

            <div
              class="confirmar-edicao-item"
              style="grid-column: 1 / -1;"
            >

              <span>
                Cartão atual
              </span>

              <strong>
                ${values.num_cartao_acesso || "Não informado"}
              </strong>

            </div>

          </div>


          <!-- AVISO -->
          <div class="confirmar-edicao-aviso">

            <svg
              width="17"
              height="17"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>

            <span>
              Após confirmar, o campo será desbloqueado para edição.
            </span>

          </div>

        </div>

      </div>
    `,

    showCancelButton: true,

    confirmButtonText: "Liberar edição",
    cancelButtonText: "Cancelar",

    confirmButtonColor: "#147fc1",
    cancelButtonColor: "#1e293b",

    reverseButtons: true,

    customClass: {
      popup: "swal-confirmar-edicao",
      actions: "swal-confirmar-edicao-actions",
      confirmButton: "swal-confirmar-edicao-confirm",
      cancelButton: "swal-confirmar-edicao-cancel"
    }

  }).then((result) => {

    if (!result.isConfirmed) return;

    setEditarCartao(true);


    /* ============================================================
       EDIÇÃO LIBERADA
    ============================================================ */

    Swal.fire({

      width: "420px",
      padding: "0",

      background: "#0f172a",
      color: "#ffffff",

      html: `
        <div class="edicao-liberada-modal">

          <div class="edicao-liberada-icon">

            <svg
              width="26"
              height="26"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M20 6 9 17l-5-5"/>
            </svg>

          </div>


          <h2>
            Edição liberada
          </h2>


          <p>
            Agora você pode alterar o cartão de acesso.
          </p>


          <span>
            O campo foi desbloqueado para edição.
          </span>

        </div>
      `,

      confirmButtonText: "Entendi",

      confirmButtonColor: "#147fc1",

      customClass: {
        popup: "swal-edicao-liberada",
        confirmButton: "swal-edicao-liberada-confirm"
      }

    });

  });
};


  //EDITAR FUNÇÃO FUNCIONARIO 

const confirmarEdicaoTipo = () => {
  if (editarTipo) return;

  Swal.fire({
    width: "520px",
    padding: "0",

    background: "#0f172a",
    color: "#ffffff",

    html: `
      <div class="confirmar-edicao-modal">

        <!-- HEADER -->
        <div class="confirmar-edicao-header">

          <div class="confirmar-edicao-icon">
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M12 20h9"/>
              <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z"/>
            </svg>
          </div>

          <div>
            <h2>
              Alterar função
            </h2>

            <span>
              Confirme para liberar a edição
            </span>
          </div>

        </div>


        <!-- CONTEÚDO -->
        <div class="confirmar-edicao-content">

          <div class="confirmar-edicao-text">
            Essa ação permitirá alterar a função do funcionário.
          </div>


          <!-- FUNÇÃO ATUAL -->
          <div class="confirmar-edicao-info">

            <div
              class="confirmar-edicao-item"
              style="grid-column: 1 / -1;"
            >

              <span>
                Função atual
              </span>

              <strong>
                ${getTipoLabel(values.tipo) || "Não informado"}
              </strong>

            </div>

          </div>


          <!-- INFORMAÇÃO IMPORTANTE -->
          <div class="confirmar-edicao-aviso">

            <svg
              width="17"
              height="17"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>

            <span>
              Ao selecionar <strong>Motorista</strong>,
              CNH, Categoria e Vencimento serão obrigatórios.
            </span>

          </div>

        </div>

      </div>
    `,

    showCancelButton: true,

    confirmButtonText: "Liberar edição",
    cancelButtonText: "Cancelar",

    confirmButtonColor: "#147fc1",
    cancelButtonColor: "#1e293b",

    reverseButtons: true,

    customClass: {
      popup: "swal-confirmar-edicao",
      actions: "swal-confirmar-edicao-actions",
      confirmButton: "swal-confirmar-edicao-confirm",
      cancelButton: "swal-confirmar-edicao-cancel"
    }

  }).then((result) => {

    if (!result.isConfirmed) return;

    setEditarTipo(true);


    /* ============================================
       EDIÇÃO LIBERADA
    ============================================ */

    Swal.fire({

      width: "440px",
      padding: "0",

      background: "#0f172a",
      color: "#ffffff",

      html: `
        <div class="edicao-liberada-modal">

          <div class="edicao-liberada-icon">

            <svg
              width="26"
              height="26"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M20 6 9 17l-5-5"/>
            </svg>

          </div>


          <h2>
            Edição liberada
          </h2>


          <p>
            Agora você pode selecionar a função.
          </p>


          <span>
            Ao salvar como <strong>Motorista</strong>,
            o sistema validará:
          </span>


          <div class="edicao-liberada-lista">

            <div>
              <span>✓</span>
              CNH
            </div>

            <div>
              <span>✓</span>
              Categoria CNH
            </div>

            <div>
              <span>✓</span>
              Vencimento CNH
            </div>

          </div>

        </div>
      `,

      confirmButtonText: "Entendi",

      confirmButtonColor: "#147fc1",

      customClass: {
        popup: "swal-edicao-liberada",
        confirmButton: "swal-edicao-liberada-confirm"
      }

    });

  });
};

  // EDITAR DATA VENCIMENTO CNH
 const confirmarEdicaoVencimento = () => {
  if (editarVencimento) return;

  const tipo = (values.tipo || "")
    .toString()
    .toLowerCase();

  /* ============================================================
     SOMENTE MOTORISTA PODE EDITAR VENCIMENTO DA CNH
  ============================================================ */

  if (tipo !== "m") {
    Swal.fire({
      width: "430px",
      padding: "0",

      background: "#0f172a",
      color: "#ffffff",

      html: `
        <div class="edicao-bloqueada-modal">

          <div class="edicao-bloqueada-icon">

            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>

          </div>

          <h2>
            Ação não permitida
          </h2>

          <p>
            Apenas funcionários com função
            <strong>Motorista</strong>
            possuem CNH.
          </p>

        </div>
      `,

      confirmButtonText: "Entendi",

      confirmButtonColor: "#147fc1",

      customClass: {
        popup: "swal-edicao-bloqueada",
        confirmButton: "swal-edicao-bloqueada-confirm"
      }
    });

    return;
  }


  /* ============================================================
     CONFIRMAÇÃO
  ============================================================ */

  Swal.fire({
    width: "520px",
    padding: "0",

    background: "#0f172a",
    color: "#ffffff",

    html: `
      <div class="confirmar-edicao-modal">

        <!-- HEADER -->

        <div class="confirmar-edicao-header">

          <div class="confirmar-edicao-icon">

            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M12 20h9"/>
              <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z"/>
            </svg>

          </div>

          <div>

            <h2>
              Alterar vencimento CNH
            </h2>

            <span>
              Confirme para liberar a edição
            </span>

          </div>

        </div>


        <!-- CONTEÚDO -->

        <div class="confirmar-edicao-content">

          <div class="confirmar-edicao-text">
            Essa ação permitirá editar a data de vencimento da CNH.
          </div>


          <!-- DATA ATUAL -->

          <div class="confirmar-edicao-info">

            <div
              class="confirmar-edicao-item"
              style="grid-column: 1 / -1;"
            >

              <span>
                Vencimento atual
              </span>

              <strong>
                ${dataVencimentoTexto || "Não informado"}
              </strong>

            </div>

          </div>


          <!-- AVISO -->

          <div class="confirmar-edicao-aviso">

            <svg
              width="17"
              height="17"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>

            <span>
              Após confirmar, o campo de data será liberado para alteração.
            </span>

          </div>

        </div>

      </div>
    `,

    showCancelButton: true,

    confirmButtonText: "Liberar edição",
    cancelButtonText: "Cancelar",

    confirmButtonColor: "#147fc1",
    cancelButtonColor: "#1e293b",

    reverseButtons: true,

    customClass: {
      popup: "swal-confirmar-edicao",
      actions: "swal-confirmar-edicao-actions",
      confirmButton: "swal-confirmar-edicao-confirm",
      cancelButton: "swal-confirmar-edicao-cancel"
    }

  }).then((result) => {

    if (!result.isConfirmed) return;

    setEditarVencimento(true);


    /* ============================================================
       EDIÇÃO LIBERADA
    ============================================================ */

    Swal.fire({

      width: "420px",
      padding: "0",

      background: "#0f172a",
      color: "#ffffff",

      html: `
        <div class="edicao-liberada-modal">

          <div class="edicao-liberada-icon">

            <svg
              width="26"
              height="26"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M20 6 9 17l-5-5"/>
            </svg>

          </div>


          <h2>
            Edição liberada
          </h2>


          <p>
            Agora você pode alterar o vencimento da CNH.
          </p>


          <span>
            O campo de data foi desbloqueado para edição.
          </span>

        </div>
      `,

      confirmButtonText: "Entendi",

      confirmButtonColor: "#147fc1",

      customClass: {
        popup: "swal-edicao-liberada",
        confirmButton: "swal-edicao-liberada-confirm"
      }

    });

  });
};




  const handleSubmit = async () => {
    const tipo = (values.tipo || "")
      .toString()
      .toLowerCase();

    if (tipo === "m") {
      if (dataVencimentoError) {
        Swal.fire({
          icon: "warning",
          title: "CNH inválida",
          text: dataVencimentoError,
          background: "#0f172a",
          color: "#fff",
          confirmButtonColor: "#f59e0b"
        });

        return false;
      }

      const data = moment(
        dataVencimentoTexto,
        "DD/MM/YYYY",
        true
      );

      if (!data.isValid()) {
        Swal.fire({
          icon: "warning",
          title: "Data inválida",
          background: "#0f172a",
          color: "#fff"
        });

        return false;
      }

      if (data.endOf("day").isBefore(moment())) {
        Swal.fire({
          icon: "warning",
          title: "CNH vencida",
          text: "Não é possível salvar.",
          background: "#0f172a",
          color: "#fff"
        });

        return false;
      }
    }

    await api.put(`/motoristass/${values.id}`, {
      ...values,
      editado_por: localStorage.getItem("clientID"),
    });

    return true;
  };




  const validarCamposMotorista = () => {
    const tipo = (values.tipo || "")
      .toString()
      .trim()
      .toLowerCase();

    // no seu sistema: m = motorista / a = acompanhante
    const ehMotorista =
      tipo === "m";

    if (!ehMotorista) return true;

    const faltando = [];

    if (!values.num_cnh?.toString().trim()) {
      faltando.push("CNH");
    }

    if (!values.categoria?.toString().trim()) {
      faltando.push("Categoria CNH");
    }

    if (!dataVencimentoTexto?.toString().trim()) {
      faltando.push("Vencimento CNH");
    }

    if (faltando.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Campos obrigatórios",

        background: "#0f172a",
        color: "#ffffff",

        html: `
        <div style="margin-top:8px">

          <div style="
            color:#cbd5e1;
            font-size:15px;
            line-height:1.6;
            margin-bottom:18px;
            text-align:center;
          ">
            Para salvar como
            <b style="color:#38bdf8">Motorista</b>,
            preencha os campos abaixo:
          </div>

          <div style="
            border:1px solid rgba(245,158,11,.22);
            border-radius:12px;
            padding:14px;
            background:rgba(245,158,11,.06);
            text-align:left;
          ">
            ${faltando
            .map(
              (campo) => `
                  <p style="
                    margin:6px 0;
                    color:#fde68a;
                  ">
                    • ${campo}
                  </p>
                `
            )
            .join("")}
          </div>

        </div>
      `,

        confirmButtonText: "Entendi",
        confirmButtonColor: "#f59e0b"
      });

      return false;
    }

    return true;
  };

  //CONFIRMAÇÃO PARA SALVAR 
  const confirmarSalvar = () => {
    // NÃO houve alteração
    if (!houveAlteracao()) {
      Swal.fire({
        title: "Nenhuma alteração encontrada",
        icon: "warning",

        background: "#0f172a",
        color: "#ffffff",

        html: `
    <div style="margin-top:8px">

      <div style="
        color:#cbd5e1;
        font-size:15px;
        line-height:1.6;
        margin-bottom:18px;
        text-align:center;
      ">
        Você realmente deseja sair da edição do funcionário?
      </div>

      <div style="
        border:1px solid rgba(56,189,248,0.18);
        border-radius:12px;
        padding:14px;
        background:rgba(255,255,255,0.03);
        text-align:left;
      ">

        <p style="margin:6px 0;color:#fff">
          <b style="color:#38bdf8">Funcionário:</b>
          ${values.nome}
        </p>

        <p style="margin:6px 0;color:#fff">
          <b style="color:#38bdf8">Status:</b>
          Nenhuma alteração realizada
        </p>

      </div>

      <div style="
        margin-top:14px;
        color:#94a3b8;
        font-size:13px;
        text-align:center;
      ">
        Se sair agora, nenhuma informação será modificada.
      </div>

    </div>
  `,

        showCancelButton: true,
        confirmButtonText: "Sim, sair",
        cancelButtonText: "Não, continuar editando",

        confirmButtonColor: "#334155",
        cancelButtonColor: "#2563eb",

        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          navigate(-1); //  volta
        }
      });

      return; //  PARA AQUI
    }


    /* ===========================
   VALIDAÇÃO AO SALVAR
=========================== */




    /* usar no salvar */

    if (!validarCamposMotorista()) return;



    //  HOUVE ALTERAÇÃO → confirmação de salvar
    Swal.fire({
      title: "Confirmar alterações?",
      icon: "warning",

      background: "#0f172a",
      color: "#ffffff",

      html: `
    <div style="margin-top:8px">

      <div style="
        color:#cbd5e1;
        font-size:15px;
        line-height:1.6;
        margin-bottom:18px;
        text-align:center;
      ">
        Deseja salvar as alterações do
        <b style="color:#38bdf8">
          ${getTipoLabel(values.tipo)}
        </b>?
      </div>

      <div style="
        border:1px solid rgba(56,189,248,0.18);
        border-radius:12px;
        padding:14px;
        background:rgba(255,255,255,0.03);
        text-align:left;
      ">

        <p style="margin:6px 0;color:#fff">
          <b style="color:#38bdf8">Nome:</b>
          ${values.nome || "Não informado"}
        </p>

        <p style="margin:6px 0;color:#fff">
          <b style="color:#38bdf8">Apelido:</b>
          ${values.apelido || "Não informado"}
        </p>

        <p style="margin:6px 0;color:#fff">
          <b style="color:#38bdf8">Tipo:</b>
          ${getTipoLabel(values.tipo)}
        </p>

        <p style="margin:6px 0;color:#fff">
          <b style="color:#38bdf8">CPF:</b>
          ${values.cpf || "Não informado"}
        </p>

      </div>

      <div style="
        margin-top:14px;
        color:#94a3b8;
        font-size:13px;
        text-align:center;
      ">
        As informações atualizadas serão gravadas no sistema.
      </div>

    </div>
  `,

      showCancelButton: true,
      confirmButtonText: "Sim, salvar",
      cancelButtonText: "Cancelar",

      confirmButtonColor: "#2563eb",
      cancelButtonColor: "#334155",

      reverseButtons: true
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      Swal.fire({
        title: "Salvando edição...",

        html: `
      <div style="margin-top:10px;overflow:hidden;">

        <div style="
          color:#cbd5e1;
          font-size:15px;
          margin-bottom:20px;
        ">
          Aguarde enquanto atualizamos os dados no sistema.
        </div>

        <div style="
          display:flex;
          justify-content:center;
          align-items:center;
        ">
          <div style="
            width:58px;
            height:58px;
            border:4px solid rgba(255,255,255,0.08);
            border-top:4px solid #38bdf8;
            border-right:4px solid #0ea5e9;
            border-radius:50%;
            animation: spinSwal 0.8s linear infinite;
          "></div>
        </div>

        <div style="
          margin-top:18px;
          color:#64748b;
          font-size:13px;
        ">
          Isso pode levar alguns segundos...
        </div>

      </div>

      <style>
        @keyframes spinSwal {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      </style>
    `,

        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,

        background: "#0f172a",
        color: "#ffffff",

        didOpen: () => {
          const popup = Swal.getPopup();
          popup.style.overflow = "hidden";
          popup.style.maxHeight = "none";
          popup.style.paddingBottom = "28px";
        }
      });

      try {
        const salvou = await handleSubmit();

        if (!salvou) {
          Swal.close();
          return;
        }

        Swal.close();

        Swal.fire({
          icon: "success",
          title: "Salvo com sucesso!",
          timer: 1800,
          showConfirmButton: false,
          background: "#0f172a",
          color: "#fff"

        }).then(() => {
          navigate("/maps/motorista"); // volta para a página anterior
        });

      } catch (error) {
        Swal.close();

        Swal.fire({
          icon: "error",
          title: "Erro ao salvar",
          text: "Não foi possível concluir a edição.",
          background: "#0f172a",
          color: "#ffffff"
        });
      }
    });
  };























  return (
    <>
      <ToastContainer />

      <div className="cadastro-enfermeiro-container cadastro-motorista-container">

        <div className="cadastro-enfermeiro-card cadastro-motorista-card">

          {/* =====================================================
            HEADER
        ===================================================== */}

          <div className="cadastro-enfermeiro-header cadastro-motorista-header">

            <div className="cadastro-header-content">

              <div className="cadastro-header-line"></div>

              <div>

                <h4 className="cadastro-enfermeiro-title">
                  Editar Motorista
                </h4>

                <span className="cadastro-enfermeiro-subtitle">
                  Atualize os dados do motorista cadastrado.
                </span>

              </div>

            </div>


            {/* BOTÃO FECHAR */}

            <button
              type="button"
              className="cadastro-close-btn"
              onClick={() => navigate(-1)}
              title="Fechar"
            >
              <span>×</span>
            </button>

          </div>


          {/* =====================================================
            BODY
        ===================================================== */}

          <div className="cadastro-enfermeiro-body cadastro-motorista-body">

            <div id="myform">

              {/* =================================================
                CAMPOS
            ================================================= */}

              <div className="cadastro-fields">


                {/* =================================================
                  NOME
              ================================================= */}

                <div className="cadastro-field">

                  <label className="cadastro-label">

                    Nome Completo

                    <span className="required">
                      *
                    </span>

                  </label>


                  <div className="cadastro-input-wrapper">

                    <input
                      type="text"
                      name="nome"
                      value={values.nome || ""}
                      onChange={handleChange}
                      disabled={!editarNome}
                      maxLength={30}
                      className="cadastro-input"
                      placeholder="Digite o nome completo"
                      autoComplete="off"
                    />


                    {/* EDITAR */}

                    <button
                      type="button"
                      onClick={confirmarEdicaoNome}
                      disabled={editarNome}
                      className="cadastro-field-action"
                      title="Editar nome"
                    >
                      <BiSolidEdit size={18} />
                    </button>

                  </div>


                  <div className="cadastro-input-footer">

                    <span>
                      Nome do motorista
                    </span>

                    <span>
                      {30 - (values.nome?.length || 0)} caracteres disponíveis
                    </span>

                  </div>

                </div>



                {/* =================================================
                  APELIDO
              ================================================= */}

                <div className="cadastro-field">

                  <label className="cadastro-label">

                    Apelido

                    <span className="required">
                      *
                    </span>

                  </label>


                  <div className="cadastro-input-wrapper">

                    <input
                      type="text"
                      name="apelido"
                      value={values.apelido || ""}
                      onChange={handleChange}
                      disabled={!editarApelido}
                      maxLength={25}
                      className="cadastro-input"
                      placeholder="Primeiro e segundo nome"
                      autoComplete="off"
                    />


                    <button
                      type="button"
                      onClick={confirmarEdicaApelido}
                      disabled={editarApelido}
                      className="cadastro-field-action"
                      title="Editar apelido"
                    >
                      <BiSolidEdit size={18} />
                    </button>

                  </div>


                  <div className="cadastro-input-footer">

                    <span>
                      Apelido do motorista
                    </span>

                    <span>
                      {25 - (values.apelido?.length || 0)} caracteres disponíveis
                    </span>

                  </div>

                </div>



                {/* =================================================
                  FUNÇÃO
              ================================================= */}

                <div className="cadastro-field">

                  <label className="cadastro-label">
                    Função
                  </label>


                  <div className="cadastro-input-wrapper">

                    <select
                      className="cadastro-input"
                      name="tipo"
                      value={values.tipo || ""}
                      onChange={handleChange}
                      disabled={!editarTipo}
                    >

                      <option value="">
                        {getTipoLabel(values.tipo)}
                      </option>

                      <option value="m">
                        Motorista
                      </option>

                      <option value="a">
                        Acompanhante
                      </option>

                    </select>


                    <button
                      type="button"
                      onClick={confirmarEdicaoTipo}
                      disabled={editarTipo}
                      className="cadastro-field-action"
                      title="Editar função"
                    >
                      <BiSolidEdit size={18} />
                    </button>

                  </div>

                </div>



                {/* =================================================
                  CPF
              ================================================= */}

                <div className="cadastro-field">

                  <label className="cadastro-label">

                    CPF

                  </label>


                  <InputMask
                    mask="999.999.999-99"
                    name="cpf"
                    value={values.cpf || ""}
                    onChange={handleChange}
                    readOnly
                    className={`cadastro-input ${cpfError ? "cadastro-input-error" : ""
                      }`}
                    placeholder="000.000.000-00"
                    autoComplete="off"
                  />


                  {cpfError && (

                    <div className="invalid-feedback d-block">
                      {cpfError}
                    </div>

                  )}

                </div>



                {/* =================================================
                  CNH
              ================================================= */}

                <div className="cadastro-field">

                  <label className="cadastro-label">

                    CNH

                  </label>


                  <input
                    type="text"
                    name="num_cnh"
                    value={values.num_cnh || ""}
                    maxLength={11}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    placeholder="Número da CNH"
                    className="cadastro-input"
                    onChange={(e) => {

                      const somenteNumeros =
                        e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 11);

                      handleChange({
                        target: {
                          name: "num_cnh",
                          value: somenteNumeros
                        }
                      });

                    }}
                    readOnly={
                      (values.tipo || "")
                        .toString()
                        .toLowerCase() !== "m"
                    }
                    autoComplete="off"
                  />

                </div>



                {/* =================================================
                  CATEGORIA CNH
              ================================================= */}

                <div className="cadastro-field">

                  <label className="cadastro-label">

                    Categoria CNH

                  </label>


                  <select
                    className="cadastro-input"
                    name="categoria"
                    value={values.categoria || ""}
                    onChange={handleChange}
                    disabled={
                      (values.tipo || "")
                        .toString()
                        .toLowerCase() !== "m"
                    }
                  >

                    <option value="">
                      Selecione a categoria
                    </option>

                    <option value="A">A</option>
                    <option value="B">B</option>
                    <option value="AB">AB</option>
                    <option value="C">C</option>
                    <option value="AC">AC</option>
                    <option value="D">D</option>
                    <option value="AD">AD</option>
                    <option value="E">E</option>
                    <option value="AE">AE</option>

                  </select>

                </div>



                {/* =================================================
                  VENCIMENTO CNH
              ================================================= */}

                <div className="cadastro-field">

                  <label className="cadastro-label">

                    Vencimento CNH

                  </label>


                  <div className="cadastro-input-wrapper">

                    <InputMask
                      mask="99/99/9999"
                      className={`cadastro-input ${dataVencimentoError
                        ? "cadastro-input-error"
                        : ""
                        }`}
                      value={dataVencimentoTexto}
                      onChange={(e) => {

                        const valor = e.target.value;

                        handleVencimentoChange(e);

                        setDataVencimentoError("");


                        if (
                          valor.replace(/\D/g, "").length === 8
                        ) {

                          const dataDigitada = moment(
                            valor,
                            "DD/MM/YYYY",
                            true
                          );


                          if (!dataDigitada.isValid()) {

                            setDataVencimentoError(
                              "Data inválida"
                            );

                            return;

                          }


                          const hoje =
                            moment().endOf("day");


                          if (
                            dataDigitada
                              .endOf("day")
                              .isBefore(hoje)
                          ) {

                            setDataVencimentoError(
                              "CNH vencida"
                            );

                            return;

                          }

                        }

                      }}
                      disabled={!editarVencimento}
                      placeholder="DD/MM/AAAA"
                      autoComplete="off"
                    />


                    <button
                      type="button"
                      onClick={confirmarEdicaoVencimento}
                      disabled={editarVencimento}
                      className="cadastro-field-action"
                      title="Editar vencimento"
                    >
                      <BiSolidEdit size={18} />
                    </button>

                  </div>


                  {dataVencimentoError && (

                    <div className="invalid-feedback d-block">
                      {dataVencimentoError}
                    </div>

                  )}

                </div>



                {/* =================================================
                  NÚMERO DO CARTÃO DE ACESSO
              ================================================= */}

                <div className="cadastro-field">

                  <label className="cadastro-label">

                    Número Cartão de acesso

                  </label>


                  <div className="cadastro-input-wrapper">

                    <input
                      type="text"
                      name="num_cartao_acesso"
                      value={values.num_cartao_acesso || ""}
                      onChange={(e) => {

                        const v =
                          e.target.value.replace(/\D/g, "");

                        setValues((prev) => ({
                          ...prev,
                          num_cartao_acesso: v
                        }));

                      }}
                      disabled={!editarcartao}
                      maxLength={10}
                      inputMode="numeric"
                      className="cadastro-input"
                      placeholder="Número do acesso"
                      autoComplete="off"
                    />


                    <button
                      type="button"
                      onClick={confirmarEdicaoCartaoAcesso}
                      disabled={editarcartao}
                      className="cadastro-field-action"
                      title="Editar número de acesso"
                    >
                      <TbLock size={18} />
                    </button>

                  </div>

                </div>



                {/* =================================================
                  CNPJ
              ================================================= */}

                <div className="cadastro-field">

                  <label className="cadastro-label">

                    CNPJ

                  </label>


                  <InputMask
                    mask="99.999.999/9999-99"
                    name="cnpj"
                    value={values.cnpj || ""}
                    onChange={handleChange}
                    readOnly
                    className="cadastro-input"
                    placeholder="CNPJ"
                    autoComplete="off"
                  />

                </div>



                {/* =================================================
                  PIS
              ================================================= */}

                <div className="cadastro-field">

                  <label className="cadastro-label">

                    Número do PIS

                  </label>


                  <InputMask
                    mask="999.99999.99-9"
                    name="num_pis"
                    value={values.num_pis || ""}
                    onChange={handleChange}
                    readOnly
                    className="cadastro-input"
                    placeholder="Número do PIS"
                    autoComplete="off"
                  />

                </div>


              </div>


              {/* =================================================
                FOOTER
            ================================================= */}

              <div className="cadastro-motorista-acoes">

                <button
                  type="button"
                  className="cadastro-motorista-btn-salvar"
                  onClick={confirmarSalvar}
                >
                  Salvar
                </button>


                <button
                  type="button"
                  className="cadastro-motorista-btn-cancelar"
                  onClick={() => navigate(-1)}
                >
                  Cancelar
                </button>

              </div>

            </div>

          </div>

        </div>

      </div>
    </>
  );
}

export default MotoristaUp;
